import * as constants from '@redbubble/design-system/src/constants';
import RulerIcon from '@redbubble/design-system/src/Icons/Ruler';
import {
  ListContent,
  ListItem,
  ListMedia,
} from '@redbubble/design-system/src/List';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import { ModalSize, useOpenModal } from '@redbubble/next/modals';
import { messages } from '../../../../components/SizeGuide/messages';
import {
  SizeGuideModalContent,
  SizeGuideModalContentLoadingState,
} from '../../../../components/SizeGuide/SizeGuideModalContent';
import type {
  Gender,
  MeasurementUnit,
  SizeGuideData,
} from '../../../../components/SizeGuide/types';
import styles from './ProductTrustSignals.module.scss';

export interface SizeGuideTrustSignalProps {
  productTypeId: string;
  workId: number;
  onClick?: () => void;
  sizeGuideData?: SizeGuideData;
  initialGender?: Gender;
  initialMeasurementUnit?: MeasurementUnit;
}

export const SizeGuideTrustSignal: React.FC<SizeGuideTrustSignalProps> = ({
  productTypeId,
  workId,
  onClick,
  sizeGuideData,
  initialGender,
  initialMeasurementUnit,
}) => {
  const intl = useIntl();
  const openModal = useOpenModal();

  const handleOnClick = () => {
    onClick?.();

    openModal({
      accessibleTitle: intl.formatMessage(messages.modalAccessibleTitle),
      content: sizeGuideData ? (
        <SizeGuideModalContent
          sizeGuideData={sizeGuideData}
          initialGender={initialGender}
          initialMeasurementUnit={initialMeasurementUnit}
          productTypeId={productTypeId}
        />
      ) : (
        <SizeGuideModalContentLoadingState />
      ),
      size: ModalSize.Large,
    });
  };

  return (
    <ListItem
      element="a"
      className={styles.pointer}
      onClick={() => handleOnClick()}
      arrow
    >
      <ListMedia>
        <RulerIcon size={constants.LARGE} />
      </ListMedia>
      <ListContent>
        <Text type="display5" display="block">
          {intl.formatMessage(messages.openButtonText)}
        </Text>
        <Text display="block" type="body2">
          {intl.formatMessage(messages.fitIndicatorTitle)}
        </Text>
      </ListContent>
    </ListItem>
  );
};
